import React from "react";

import { makeStyles } from "@material-ui/core";
import PropTypes from "prop-types";

import RbInputLabel from "components/RbInputLabel";

const useStyles = makeStyles(({ palette: { custom } }) => ({
  root: {
    border: 0,
    margin: 0,
    padding: 0,
  },
  spots: {
    display: "flex",
    flexWrap: "wrap",
  },
  color: {
    width: 36,
    height: 36,
    marginRight: 8,
    marginBottom: 8,
    overflow: "hidden",
  },
  colorActive: {
    outline: `2px solid ${custom.low}`,
  },
  label: {
    position: "absolute",
    top: -9999,
  },
  input: {
    position: "absolute",
    width: 40,
    height: 40,
    margin: 0,
    opacity: 0,
  },
}));

function ColorControl(props) {
  const { colors = [], value, onChange } = props;

  const classes = useStyles();

  return (
    <fieldset className={classes.root}>
      <RbInputLabel component="legend">Color</RbInputLabel>
      <div className={classes.spots}>
        {colors.map((color) => (
          <div
            key={color}
            className={`${classes.color} ${
              value === color ? classes.colorActive : ""
            }`}
            style={{ background: color }}
          >
            <label htmlFor={color} className={classes.label}>
              {color}
            </label>
            <input
              className={classes.input}
              type="radio"
              id={color}
              value={color}
              checked={value === color}
              onChange={(event) => onChange(event.target.value)}
            />
          </div>
        ))}
      </div>
    </fieldset>
  );
}

ColorControl.propTypes = {
  colors: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

export default React.memo(ColorControl);
